import MwLiTree from "./tree/li.vue";
export default {
  components: {
    MwLiTree
  },
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me = this, commentId=$uuid();
    return {
      title: $lang('虚拟日志'),
      commentId: commentId,
      commentCategory: '',
      leading: 1,
      isAgentRecord: 1,
      agentType: 'SECRETARY',
      agentRecordActs:[],
      form: {
        comment: '',
        agentRecordActId:''
      },
      formRules: {
        comment: [{required: true, message: $lang("请输入办理意见"), trigger: "blur"}]
      },
      footerButton: [
        {
          label: $lang("关闭"),
          type: "default",
          func: me.close
        },
        {
          label: $lang("确定"),
          func: me.submit
        }
      ],
      srcAgentRecordActs:[],
      currentArActId:'',
      currentCandidates:[],
      currentPlannedes:[],
      cpActivities:{}
    }
  },
  mounted() {
    var me = this;
    setTimeout(() => {
      this.show();
    }, 200)
    me.commentId = $uuid();
    me.commentCategory = me.params.activity.commentCategory;
    me.form.comment = '';
    me.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    init(){
      var me = this;
      me.mwApi.process.getFlows(me.params.taskId, me.params).then(res => {
       // me.srcAgentRecordActs = me.params.agentRecordActs;
        var srcAgentRecordFlowIds = me.params.agentRecordFlowIds;
        me.agentRecordActs = [];
        //过滤
        if(res.success && res.result){
           var flows = res.result;
           var fi=0;
           flows.forEach(f=>{
                /*var act = me.srcAgentRecordActs[f.activityId];
                if(act){
                  act.flowId = f.id;
                  if(f.activityName){
                    act.name = f.activityName;
                  }
                  me.agentRecordActs[fi++] = act;
                }*/
             srcAgentRecordFlowIds.forEach(arf=>{
               if(arf ==f.id){
                    var act = {id:f.activityId, name:f.activityName, flowId:f.id};
                    me.srcAgentRecordActs[f.activityId] = act;
                    me.agentRecordActs[fi++] = act;
               }
             });
           });
           if(me.agentRecordActs.length> 0){
             me.form.agentRecordActId = me.agentRecordActs[0].id;
             me.currentArActId = me.agentRecordActs[0].id;
             me._getCurrentArActivityCandidates();
           }
        }
      });
    },
    setBtnLoading(loading, idx){
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      let me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    changeAgentRecordAct(val){
      var me = this;
      me.currentArActId = val;
      var currentCp = me.cpActivities[val];
      if(null != currentCp){
        me.currentPlannedes = currentCp['planned'];
        me.currentCandidates= currentCp['candidate'];
        me.mwRef('planned').refreshData(me.currentPlannedes);
        me.mwRef('candidate').refreshData(me.currentCandidates);
        return;
      }
      me._getCurrentArActivityCandidates();
    },
    _getCurrentArActivityCandidates(){
      var me = this;
      var act = me.srcAgentRecordActs[me.currentArActId];
      me.mwApi.process.getNextActivityCandidates({taskId:me.params.taskId, flowId: act.flowId}).then((data)=>{
        let res=data.result;
        if(typeof res.success !='undefined' && !res.success){
          me.currentPlannedes = [];
          me.currentCandidates=[];
        }else{
          me.currentPlannedes = [];
          me.currentCandidates=res;
        }
        me.cpActivities[me.currentArActId] = {'planned':me.currentPlannedes, 'candidate':me.currentCandidates};
        if(me.mwRef('candidate')){
          me.mwRef('candidate').refreshData(me.currentCandidates);
        }
        if(me.mwRef('planned')){
          me.mwRef('planned').refreshData(me.currentPlannedes);
        }
      });
    },
    candidateDataHandle(data){
      for(var i=0; i< data.length; i++){
        var d = data[i];
        if (!d.text) {
          if (d.name)
            d.text = d.name;
        }
        if (!d.originalId) {
          d.originalId = d.id; //原ID赋值给originalId
          if (d.departmentId) {
            d.id = d.departmentId + '_' + d.id;
          }
        }
        if(!d.idx && d.idx !=0){
          d.idx = i;
        }
      }
    },
    dblClick(data){ //移入已选
      var me = this;
      //移出可选框
      var fcandidate = me.currentCandidates;
      var idx;
      fcandidate.map((v, d) => {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.currentCandidates.splice(idx, 1);
      //移入已选框
      var node = Object.assign({}, data);
      node.text = data.name;
      me.currentPlannedes.push(node);
      me.mwRef('planned').refreshData(me.currentPlannedes);
      me.cpActivities[me.currentArActId] = {'planned':me.currentPlannedes, 'candidate':me.currentCandidates};
    },
    dblClickSelected(data){ //移入到可选
      var me = this;
      //移出已选框
      var fplanned = me.currentPlannedes;
      let idx;
      fplanned.map((v, d) => {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.currentPlannedes.splice(idx, 1);
      //移入可选框
      var node = Object.assign({}, data);
      node.text = data.name;
      var cidx = node.idx;
      if (cidx || cidx == 0) {
        me.currentCandidates.splice(cidx, 0, node);
      } else {
        me.currentCandidates.push(node);
      }
      me.mwRef('candidate').refreshData(me.currentCandidates);
      me.cpActivities[me.currentArActId] = {'planned':me.currentPlannedes, 'candidate':me.currentCandidates};
    },
    submit(){
      let me = this;
      if(me.currentPlannedes.length< 1){
        me.mwMsg('info', $lang("请先选择可选领导"));
        return;
      }
      this.mwRef("virtuallogForm").validate(valid => {
        if(valid) {
            me.btnDebounce(function () {
            me.setBtnLoading(true, 1);
            var act = me.srcAgentRecordActs[me.currentArActId];
            let params = {};
            params.type = "virtualRecord";
            params.isAgentRecord = me.isAgentRecord;
            params.appId = me.params.appId;
            params.formId = me.params.formId;
            params.taskId = me.params.taskId;

            var items=[];
            me.currentPlannedes.map((plan) => {
              items.push(me._nodeAsItem(plan));
            });
            params.activities = [{activityId:act.id, items:items, flowId:act.flowId}];
            params.$comment = [{
              id: me.commentId,
              content: me.form.comment,
              category: me.commentCategory,
              leading: me.leading,
              isAgentRecord: me.isAgentRecord,
              agentType: me.agentType
            }];
            me.mwApi.process.saveVirtualRecord(params).then((res) => {
              me.close();
              me.formActionComplete(params);
              me.setBtnLoading(false, 1);
            }).catch(() => {
              me.setBtnLoading(false, 1);
            });
          });
        }else{
          //me.mwMsg("信息未填写完整");
          return;
        }
      });
    },
    beforeClose(done){
      var me = this;
      //me.mwConfirm('确认退出虚拟日志窗口？').then(_ => {
        if (me.params.secondfunc) {
          me.params.secondfunc()
        }
        me.resetForm();
        done();
      // }).catch(_ => {
      // });
    },
    resetForm(){
      var me = this;
      me.form.comment = '';
      me.commentId = $uuid();
      me.commentCategory = '';
    },
    formActionComplete(){
      let me = this;
      if (me.params.func) {
        me.params.func()
      }
      this.resetForm();
    },
    show(){
      this.mwRef('dialog').show();
    },
    close(){
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    _nodeAsItem(n){
      var item = {};
      item.group = n.departmentId;
      if (!item.users) {
        item.users = [];
      }
      item.users.push({id: n.originalId});
      return item;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/public-dialog/virtuallog.js